import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import AppLogo from "../components/AppLogo";

const T = {
  g600: "#155c36", g500: "#1e9254", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n700: "#2d3549", n600: "#4a5268", n400: "#8a93a8",
  n150: "#e4e7ef", white: "#ffffff",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

export default function ProApplicationRejectedPage() {
  const navigate = useNavigate();
  const [reason, setReason] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { setLoading(false); return; }
      const { data } = await supabase
        .from("pro_profiles")
        .select("rejection_reason")
        .eq("id", user.id)
        .single();
      setReason(data?.rejection_reason || null);
      setLoading(false);
    })();
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: T.white, fontFamily: T.sans, display: "flex", flexDirection: "column" }}>
      <header style={{ height: 60, display: "flex", alignItems: "center", padding: "0 24px", borderBottom: `1px solid ${T.n150}` }}>
        <AppLogo />
      </header>

      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
        <div style={{ maxWidth: 480, textAlign: "center" }}>
          <div style={{
            width: 56, height: 56, borderRadius: "50%", background: "#fdf3f2",
            border: "1.5px solid #f5c0bb", display: "flex", alignItems: "center",
            justifyContent: "center", margin: "0 auto 24px",
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c0392b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>

          <h1 style={{
            fontFamily: T.serif, fontSize: 32, fontWeight: 400, color: T.n900,
            margin: "0 0 12px", letterSpacing: "-0.03em",
          }}>
            We're sorry, we can't approve your application right now.
          </h1>

          <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.65, margin: "0 0 8px" }}>
            After review, we weren't able to verify your JiraniPro application at this time.
          </p>

          {!loading && reason && (
            <div style={{
              background: T.g50, border: `1px solid ${T.g100}`, borderRadius: 12,
              padding: "16px 18px", margin: "20px 0", textAlign: "left",
            }}>
              <p style={{ fontSize: 11, fontWeight: 600, color: T.g600, textTransform: "uppercase",
                letterSpacing: "0.06em", margin: "0 0 6px" }}>Reviewer note</p>
              <p style={{ fontSize: 14, color: T.n700, margin: 0, lineHeight: 1.6 }}>{reason}</p>
            </div>
          )}

          <p style={{ fontSize: 13, color: T.n400, margin: "20px 0 32px", lineHeight: 1.65 }}>
            You're welcome to update your information and reapply, or reach out if you think this was a mistake.
          </p>

          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => navigate("/pro-onboarding")}
              style={{
                height: 48, padding: "0 28px", background: T.g500, color: T.white,
                border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
                cursor: "pointer", fontFamily: T.sans,
              }}
            >
              Reapply
            </button>
            <button
              onClick={() => navigate("/")}
              style={{
                height: 48, padding: "0 28px", background: T.white, color: T.n600,
                border: `1px solid ${T.n150}`, borderRadius: 10, fontSize: 14, fontWeight: 500,
                cursor: "pointer", fontFamily: T.sans,
              }}
            >
              Return home
            </button>
          </div>

          <p style={{ fontSize: 12, color: T.n400, marginTop: 24 }}>
            Questions? <a href="mailto:support@jiraniapp.com" style={{ color: T.g500, textDecoration: "none" }}>support@jiraniapp.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}